import { View } from "@faire/retailer-visitor-shared/components/AppSignIn/components/View";
import { trackSigninFieldChangeKeyboardInput } from "@faire/web-api--source/events/signin/keyboardInput/fieldChange";
import { trackSigninLoginPageSubmit } from "@faire/web-api--source/events/signin/submit/loginPage";
import { trackSigninLoginModalView } from "@faire/web-api--source/events/signin/view/loginModal";
import { useCallback } from "react";

export const useSignInEventTracker = (currentView: keyof typeof View) => {
  const trackView = useCallback(() => {
    trackSigninLoginModalView(currentView);
  }, [currentView]);

  const trackFieldValue = useCallback(
    (fieldName: string, fieldValue: string) => {
      trackSigninFieldChangeKeyboardInput(fieldName, fieldValue, currentView);
    },
    [currentView]
  );

  const trackSubmit = useCallback(() => {
    trackSigninLoginPageSubmit(currentView);
  }, [currentView]);

  return { trackView, trackSubmit, trackFieldValue };
};
